import React from 'react';

const ConfigContext = React.createContext({});

export const useConfig = () => React.useContext(ConfigContext);

export default function ConfigProvider({ value = {}, children }) {
  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
}
